module.exports = __webpack_public_path__ + "static/media/nav-signing-hover.b1dfe98d.svg";